import {
  Blockquote,
  Container,
  Heading3,
  Heading6,
  OrderedList,
} from "shared/components";

import styles from "./Content020.module.scss";

export const Content020 = ({ payload }) => {
  const title = payload?.title ?? "";
  const subtitle = payload?.subtitle ?? "";
  const quote = payload?.quoteText ?? "";
  const author = payload?.quoteAuthor ?? "";
  const position = payload?.quoteAuthorPosition ?? "";
  const list = payload?.list ?? {};
  const image = payload?.quoteImage ?? {};

  return (
    <div className={styles.wrapper}>
      <Container className={styles.inner}>
        <Heading3 className={styles.title}>{title}</Heading3>
        <div className={styles.block}>
          <div className={styles.content}>
            <Heading6 className={styles.subtitle}>{subtitle}</Heading6>
            <OrderedList
              items={list}
              className={styles.full}
              appearance="bigger"
            />
          </div>
          <div className={styles.blockquote}>
            <Blockquote
              image={image}
              author={author}
              position={position}
              quote={quote}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content020;
